// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX
// MODFIED DATA : 06-12-2025

import staffReportActionTypes from './staff-report.types';

/** ***************** FECTH STAFF DETAIL REPORT START *********************** */
export const getStaffDetailsStart = (addData: any) => ({
	type: staffReportActionTypes.GET_STAFF_DETAILS_START,
	payload: addData,
});

export const getStaffDetailsSuccess = (successData: any) => ({
	type: staffReportActionTypes.GET_STAFF_DETAILS_SUCCESS,
	payload: successData,
});

export const getStaffDetailsFailure = (failureData: any) => ({
	type: staffReportActionTypes.GET_STAFF_DETAILS_FAILURE,
	payload: failureData,
});

export const getStaffDetailsResponseResetStart = () => ({
	type: staffReportActionTypes.GET_STAFF_DETAILS_RESPONSE_CHANGED,
});

export const getStaffDetailsResponseChanged = () => ({
	type: staffReportActionTypes.GET_STAFF_DETAILS_RESPONSE_RESET,
});
/** ************** FECTH STAFF DETAIL REPORT END ********** */

/** ************ GET STAFF OOFICER REPORT START ************* */
export const getStaffOfficerDetailsStart = (addData: any) => ({
	type: staffReportActionTypes.GET_STAFF_OFFICER_START,
	payload: addData,
});

export const getStaffOfficerDetailsSuccess = (successData: any) => ({
	type: staffReportActionTypes.GET_STAFF_OFFICER_SUCCESS,
	payload: successData,
});

export const getStaffOfficerDetailsFailure = (failureData: any) => ({
	type: staffReportActionTypes.GET_STAFF_OFFICER_FAILURE,
	payload: failureData,
});

export const getStaffOfficerDetailsResponseReset = () => ({
	type: staffReportActionTypes.GET_STAFF_OFFICER_RESPONSE_CHANGED,
});

export const getStaffOfficerDetailsResponseChanged = () => ({
	type: staffReportActionTypes.GET_STAFF_OFFICER_RESPONSE_RESET,
});

/** ************ GET STAFF OOFICER REPORT END ************* */
